
import React, { useEffect, useMemo, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useParams } from 'react-router';

import { ModalContent, ModalActions } from '@vromo/ui/components/Modal';
import { Platform } from '@vromo/models';
import Button from '@vromo/ui/components/Button';
import { useIntegrationLocations, useIntegrationsActions, useIntegrationsNav, useIntegrationsPage } from '../../hooks';
import { FilterRow } from '@vromo/dashboard/src/blueprints/BlueprintStyles';
import Input from '@vromo/ui/components/Input';




/** modal to created / add a new integration */
export const UberEatsKHConfigure = observer(() => {

    const {
        cancelIntegrationConfig, startIntegrationAuth,
    } = useIntegrationsActions()
    const { createLocations } = useIntegrationLocations()
    const { isLoading, fetched, fetchedIntegrations, setLoading } = useIntegrationsPage()
    const { platform } = useParams<{ platform: Platform }>()
    const instance = fetchedIntegrations.get(platform)
    const [isAuthenticated, setIsAuthenticated] = useState(false)
    const [newExtLocation, setNeExtLocation] = useState({
        name: "",
        street: "",
        city: "",
        state: "",
        zipcode: "",
        providerStoreId: "",
        platform: Platform.uberEatsKH
    })

    const isValidLocation = useMemo(
        function validateNewLocationInput() {
            const allFilled = Object.values(newExtLocation).filter(val => val.length < 3).length < 1
            const storeIdNotInUse = (instance?.ext_locations ?? []).filter(location => location.ext_site_id !== newExtLocation.providerStoreId)
            return allFilled && storeIdNotInUse
        }, [newExtLocation, instance]
    )


    useEffect(() => {
        if (instance?.ext_locations?.length)
            setIsAuthenticated(true)
    }, [instance])

    useEffect(
        /** if no uber locations founds, this means that probably customer has never auth to uber - kitchenhub */

        function authUberKHAccess() {
            if (
                fetched &&
                !instance?.features?.configAuthOnlyUrl &&
                !isLoading &&
                instance?.status !== "error"
            )
                startIntegrationAuth(platform)
        }, [fetched, isLoading, instance])




    return (
        <>
            {
                <ModalContent >
                    {
                        !isAuthenticated &&
                        <>
                            <h4>Vromo needs to be able to access your Uber Eats account</h4>
                            <p>
                                In order to do so, please click "Grant access" below.<br /> A Uber login form will be presented in order to provide the required access
                            </p>
                        </>
                    }
                    {
                        isAuthenticated && !instance?.ext_locations?.length &&
                        <h4>Please ensure you complete the form on {platform} popup window</h4>
                    }
                    {
                        isAuthenticated &&
                        <>
                            <h4>
                                {"External Store configuration"}
                            </h4>
                            <FilterRow>
                                <Input
                                    label={`Your ${platform} store ID`}
                                    value={newExtLocation.providerStoreId}
                                    disabled={!isAuthenticated}
                                    placeholder={"4bce....-....-.....-....-....fe872"}
                                    onChange={e => setNeExtLocation({ ...newExtLocation, providerStoreId: e.target.value.trim() })}
                                />
                            </FilterRow>
                            <FilterRow>
                                <Input
                                    label={`Your ${platform} store name`}
                                    value={newExtLocation.name}
                                    disabled={!isAuthenticated}
                                    onChange={e => setNeExtLocation({ ...newExtLocation, name: e.target.value.trim() })}
                                />
                            </FilterRow>
                            <FilterRow>
                                <Input
                                    label="Street"
                                    value={newExtLocation.street}
                                    disabled={!isAuthenticated}
                                    onChange={e => setNeExtLocation({ ...newExtLocation, street: e.target.value.trim() })}
                                />
                                <Input
                                    label="Zipcode"
                                    value={newExtLocation.zipcode}
                                    disabled={!isAuthenticated}
                                    onChange={e => setNeExtLocation({ ...newExtLocation, zipcode: e.target.value.trim() })}
                                />
                            </FilterRow>
                            <FilterRow>
                                <Input
                                    label="City"
                                    value={newExtLocation.city}
                                    disabled={!isAuthenticated}
                                    onChange={e => setNeExtLocation({ ...newExtLocation, city: e.target.value.trim() })}
                                />
                                <Input
                                    label="State"
                                    value={newExtLocation.state}
                                    disabled={!isAuthenticated}
                                    onChange={e => setNeExtLocation({ ...newExtLocation, state: e.target.value.trim() })}
                                />
                            </FilterRow>
                        </>
                    }
                </ModalContent>
            }
            {
                fetched && instance &&
                <ModalActions >
                    {
                        <Button onClick={() => cancelIntegrationConfig({
                            iframe: true,
                            platform,
                            skipConfirm: false,
                        })}>
                            cancel
                        </Button>
                    }
                    {
                        !isAuthenticated &&
                        <Button
                            darkGrey
                            onClick={() => {
                                const uberWindow = window.open(instance?.features?.configAuthOnlyUrl, 'uber', 'height=600px,width=600px')
                                uberWindow?.focus()
                                setIsAuthenticated(true)
                            }}
                        >
                            Grant Required Vromo Uber access
                        </Button>
                    }
                    {
                        isAuthenticated &&
                        <Button
                            primary
                            disabled={!isValidLocation}
                            onClick={async () => {
                                await createLocations(platform, {
                                    name: newExtLocation.name,
                                    providerStoreId: newExtLocation.providerStoreId,
                                    location: {
                                        street: newExtLocation.street,
                                        city: newExtLocation.city,
                                        state: newExtLocation.state,
                                        zipcode: newExtLocation.providerStoreId,
                                    }
                                })
                                // await closeModal()
                                cancelIntegrationConfig({
                                    iframe: true,
                                    platform,
                                    skipConfirm: true,
                                })
                            }}
                        >
                            {`Save new store configuration`}
                        </Button>
                    }
                </ModalActions>
            }
        </>
    )
});
